import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";


const StyledButton = styled.button`
	border: ${({border}) => border};
	background: ${({color}) => color};
	color: ${({fontColor}) => fontColor};
	font-size: ${({fontSize}) => `${fontSize}px`};
	font-weight: ${({bold}) => bold ? 'bold' : 'normal'};
	padding: ${({padding}) => padding};
	border-radius: ${({roundness}) => `${roundness}px`};
`;

function Button({ color="lightgray", fontColor="black", fontSize=18, bold=false,
                 padding="6px 15px", margin="0", href, style, type="button", onClick,
                 border="none", roundness=10, children, ...props }) {
    if (href) {
        return (
            <Link to={href}>
                <StyledButton
                    color={color} fontColor={fontColor} bold={bold} padding={padding} margin={margin}
                    type={type} onClick={onClick} style={style} roundness={roundness} fontSize={fontSize} {...props}
                >
                    {children}
                </StyledButton>
            </Link>
        )
    } else {
        return (
            <StyledButton
                color={color} fontColor={fontColor} bold={bold} padding={padding} margin={margin}
                type={type} onClick={onClick} style={style} roundness={roundness} fontSize={fontSize} {...props}
            >
                {children}
            </StyledButton>
        )
    }
}

export default Button;
